import usePortfolio from "../../hooks/PortfolioProvider"
import PortUtils from "../../portlibs/PortUtils"
import { usePath } from "../../libs/path/PathProvider"
import Summarize from "../../models/Summarize"
import Utils from "../../libs/Utils"
import useDateRangeFilter from "../../portlibs/DateRangeFilterProvider"
import { ForwardedRef, forwardRef, useImperativeHandle, useMemo } from "react"
import LineChart, { type TLineChartData } from "../../gui/Chart/LineChart"

export interface IAssetChart {
    export:Function
}
export default forwardRef(({}, ref?:ForwardedRef<IAssetChart>) => {
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const {start, end:_end} = useDateRangeFilter()
    let holdings = portfolio.filter(currency, filter, account, false)
    const now = new Date()
    const end = _end < now ? _end : now
    useImperativeHandle(ref, () => ({
        export() {Utils.exportFile(new Blob([Summarize.data(holdings, start, end, true).join("\n")], {type:"text/csv;charset=utf-8"}), `Home ${Utils.formatDate("yyyy-MM-dd", new Date())}.csv`)}
    }), [holdings])

    const data = useMemo(() => {
        const data = Summarize.graph(holdings, start, end)
        data.unshift(["Date", "Asset"])
        return data
    }, [account,currency,filter,end])
    
    const value = (num:number) => PortUtils.formatCurrency(0, num)
    return <LineChart className="chart" data={data.slice(1) as TLineChartData[]} value={value}/>
})